import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";

import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import MeaButton from "./MeaButton";

const MeaCreateModal = forwardRef((props, ref) => {

  //
  const [active, setActive] = useState(false);
  const [callbackFn, setCallbackFn] = useState(() => { });
  const [elementQuery, setElementQuery] = useState();
  //
  const [loading, setLoading] = useState(false);
  //
  const toast = useRef(null);
  //
  const handleCreateSubmit = async (e) => {
    // Handle create slot submit logic here
    if (loading || props.submitDisabled) {
      return;
    }
    setLoading(true);
    toast.current.show({
      severity: "info",
      summary: "Info",
      sticky: true,
      detail: "Création en cours...",
    });

    props.serviceAPI
      .CreateOne(props.schoolId, props.trainingId, props.accessToken || "", props.data)
      .then((data) => {
        toast.current.clear();
        toast.current.show({
          severity: "success",
          summary: "Succès",
          detail: data?.data?.name || data?.meta?.kind + " crée!",
        });
        setActive(false);
        callbackFn();
        // 
        if (props.onSubmitted) {
          props.onSubmitted();
        }
        if (props.onSubmitSuccess) {
          props.onSubmitSuccess();
        }
        //
      })
      .catch((err) => {
        toast.current.clear();
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de création! " + err,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  //
  useImperativeHandle(ref, () => ({
    show: (callback, elementQuery) => {
      setCallbackFn(() => callback);
      setElementQuery(elementQuery);
      setActive(true);
    },
    getElementQuery: () => elementQuery,
    submit: () => {
      handleCreateSubmit();
    },
  }));
  //

  const footerContent = (
    <div>
      <MeaButton
        label="Annuler"
        icon="pi pi-times"
        disabled={loading}
        onClick={() => setActive(false)}
        className="p-button-text"
      />
      <MeaButton
        type="submit"
        loading={loading}
        disabled={loading || props.submitDisabled}
        label="Créer"
        icon="pi pi-check"
        onClick={() => handleCreateSubmit()}
      />
    </div>
  );

  return (
    <>

      <Dialog
        focusOnShow={false}
        header={props.title}
        visible={active}
        style={props.dialogStyle || { width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        contentStyle={props.contentStyle || { overflowY: "auto", maxHeight: "70vh" }}
        onShow={() => props.onShow && props.onShow()}
        onHide={() => setActive(false)}
        footer={footerContent}
      >
        <Toast ref={toast} life={6000} />
        <div className="w-full">
          <div className="flex flex-column gap-2">{props.children}</div>
        </div>
      </Dialog>

    </>
  );
});

export default MeaCreateModal;
